import { NgModule } from 'ng-metadata/core';
import {JwtUtilService} from './jwtUtil.service';
import {UserSessionManagerService} from './userSessionManager.service';
import {UsernamePasswordLoginService} from './usernamePasswordLogin.service';
import {UsernamePasswordLoginController} from './usernamePasswordLogin.directive';
import {LoginModule} from './login/login.module';

@NgModule({
    declarations: [
        UsernamePasswordLoginController
    ],
    providers: [
        JwtUtilService,
        UsernamePasswordLoginService,
        UserSessionManagerService
    ],
    imports:[
        LoginModule
    ]
})

export class SecurityModule{}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/security-metadata.module.ts